import { useCallback } from 'react';
import { trackEvent, trackAdInteraction } from '../utils/analytics';

/**
 * Custom hook for tracking analytics events
 * Provides convenient methods for tracking different types of events
 */
const useAnalytics = () => {
  /**
   * Track a custom event
   */
  const trackCustomEvent = useCallback((eventName: string, properties?: Record<string, string | number | boolean>) => {
    trackEvent(eventName, properties);
  }, []);

  /**
   * Track when an ad is viewed
   */
  const trackAdView = useCallback((adId: string, position?: string) => {
    trackAdInteraction(adId, 'view', position);
  }, []);

  /**
   * Track when an ad is clicked
   */
  const trackAdClick = useCallback((adId: string, position?: string) => {
    trackAdInteraction(adId, 'click', position);
  }, []);

  /**
   * Track when an ad is dismissed
   */
  const trackAdDismiss = useCallback((adId: string, position?: string) => {
    trackAdInteraction(adId, 'dismiss', position);
  }, []);

  /**
   * Track user engagement with features
   */
  const trackFeatureUsage = useCallback((featureName: string, action: string) => {
    trackEvent('feature_usage', { feature: featureName, action });
  }, []);

  return {
    trackCustomEvent,
    trackAdView,
    trackAdClick,
    trackAdDismiss,
    trackFeatureUsage
  };
};

export default useAnalytics; 